import { render } from "./IconPerson.vue?vue&type=template&id=d20d55c4"
import script from "./IconPerson.vue?vue&type=script&lang=js"
export * from "./IconPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__